import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferYoutubeToYoutubeMusic() {
    return (
        <GuidesPage
            seoData={seoContent.transferYoutubeToYoutubeMusic}
            sections={<PairTransferGuideContent sourceKey="youtube" destKey="youtubeMusic" />}
        />
    );
}
